<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12 pageheader">
      <div class="fl-right">
        <button
          type="button"
          pButton
          class="ui-button-success btnmr btnpad"
          (click)="exportToCSV()">
          <i class="mdl2-excel"></i> Export To CSV
        </button>
        <button
          type="button"
          pButton
          class="ui-button-info btnpad"
          (click)="createNewPaymentBatch()">
          <i class="fa fa-plus-circle"></i> Create A New Payment Batch
        </button>
      </div>
    </div>
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      <div class="inventory card">
        <p-table
          #dt
          [columns]="pscols"
          [value]="eventPaymentBatchList"
          selectionMode="single"
          [loadingIcon]="loadingIcon"
          [showLoader]="true"
          [scrollable]="true"
          [style]="{ width: '100%' }"
          scrollHeight="500px"
          [paginator]="true"
          [rows]="dataViewRecsPerPage"
          [pageLinks]="pageLinksPerPage"
          paginatorPosition="top"
          (onPage)="pageChange($event)"
          (onFilter)="applyFilter($event)">
          <ng-template pTemplate="caption">
            <div style="text-align: left">
              <input
                type="text"
                pInputText
                size="30"
                placeholder="Search"
                (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                style="width: auto"
                [value]="
                  dt.filters['global'] ? $any(dt.filters['global']).value : ''
                " />
              <i class="fa fa-search ml-2"></i>
              <span class="pageInfo visiblelg resettble">{{
                currentPageInfo
              }}</span>
              <span style="float: right; position: relative; top: 12px"
                ><a (click)="reset()" (keydown.enter)="reset()" tabindex="0"
                  ><span class="fa fa-repeat"></span> Reset table</a
                ></span
              >
            </div>
          </ng-template>
          <ng-template #header let-columns>
            <tr>
              <th [pSortableColumn]="'paymentBatchName'" class="colsmall">
                Payment Batch Name<p-sortIcon
                  [field]="'paymentBatchName'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'paymentBatchScheduleDate'"
                class="collarge">
                Payment Batch Schedule Date<p-sortIcon
                  [field]="'paymentBatchScheduleDate'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'paymentBatchStatus'" class="colmedium">
                Payment Batch Status<p-sortIcon
                  [field]="'paymentBatchStatus'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'actualPaymentCentralDate'"
                class="colmedium">
                Actual Payment Central Date<p-sortIcon
                  [field]="'actualPaymentCentralDate'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'totalAmount'" class="colxsmall">
                Total Amount<p-sortIcon [field]="'totalAmount'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'eventRegistrationIds'" class="colsmall">
                {{ eventRegistrationIds
                }}<p-sortIcon [field]="'eventRegistrationIds'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'noOfEvents'" class="colsmall">
                {{ noOfEvents }}<p-sortIcon [field]="'noOfEvents'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'partnersIds'" class="colsmall">
                Partner's Paid<p-sortIcon [field]="'partnersIds'"></p-sortIcon>
              </th>
            </tr>
            <tr>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'paymentBatchName',
                      'contains'
                    )
                  "
                  [value]="
                    dt.filters['paymentBatchName']
                      ? $any(dt.filters['paymentBatchName']).value
                      : ''
                  " />
              </th>
              <th class="dashtable collarge">
                <input
                  pInputText
                  type="text"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'paymentBatchScheduleDate',
                      'contains'
                    )
                  "
                  [value]="
                    dt.filters['paymentBatchScheduleDate']
                      ? $any(dt.filters['paymentBatchScheduleDate']).value
                      : ''
                  " />
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'paymentBatchStatus',
                      'contains'
                    )
                  "
                  [value]="
                    dt.filters['paymentBatchStatus']
                      ? $any(dt.filters['paymentBatchStatus']).value
                      : ''
                  " />
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'actualPaymentCentralDate',
                      'contains'
                    )
                  "
                  [value]="
                    dt.filters['actualPaymentCentralDate']
                      ? $any(dt.filters['actualPaymentCentralDate']).value
                      : ''
                  " />
              </th>
              <th class="dashtable colxsmall">
                <input
                  pInputText
                  type="text"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'totalAmount',
                      'contains'
                    )
                  "
                  [value]="
                    dt.filters['totalAmount']
                      ? $any(dt.filters['totalAmount']).value
                      : ''
                  " />
              </th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'eventRegistrationIds',
                      'contains'
                    )
                  "
                  [value]="
                    dt.filters['eventRegistrationIds']
                      ? $any(dt.filters['eventRegistrationIds']).value
                      : ''
                  " />
              </th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'noOfEvents',
                      'contains'
                    )
                  "
                  [value]="
                    dt.filters['noOfEvents']
                      ? $any(dt.filters['noOfEvents']).value
                      : ''
                  " />
              </th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="
                    dt.filter(
                      $any($event.target).value,
                      'partnersIds',
                      'contains'
                    )
                  "
                  [value]="
                    dt.filters['partnersIds']
                      ? $any(dt.filters['partnersIds']).value
                      : ''
                  " />
              </th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr>
              <td class="colsmall">
                <a
                  (click)="editPaymentBatchDetails(rowData.paymentBatchName)"
                  (keydown.enter)="
                    editPaymentBatchDetails(rowData.paymentBatchName)
                  "
                  tabindex="0"
                  class="editlink"
                  >{{ rowData.paymentBatchName }}</a
                >
              </td>
              <td class="collarge">
                {{ rowData.paymentBatchScheduleDate | date: 'yyyy-MM-dd' }}
              </td>
              <td class="colmedium">{{ rowData.paymentBatchStatus }}</td>
              <td class="colmedium">
                {{ rowData.actualPaymentCentralDate | date: 'yyyy-MM-dd' }}
              </td>
              <td class="colxsmall">{{ rowData.totalAmount }}</td>
              <td class="colsmall">{{ rowData.eventRegistrationIds }}</td>
              <td class="colsmall">{{ rowData.noOfEvents }}</td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.partnersIds }}"
                  >{{ rowData.partnersIds }}</span
                >
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
